import { Link } from '@tanstack/react-router'
import { Layers } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import { useProductDetail } from '../hooks/use-product-detail'
import { formatShare } from '@/shared/lib/stock-quantity'

/**
 * "Variante von …" above a variant's tabs (CHG-2026-09-stock-usage-and-price-twins, 10.6): links
 * the source and states the share; inherited fields on the Info tab are marked "von Quelle".
 */
export function VariantSourceBanner({
  sourceSku,
  share,
  pausedBySource = false,
}: {
  sourceSku: string
  share: number
  /** The variant is inactive because its source is. */
  pausedBySource?: boolean
}) {
  const { t: tProducts } = useTranslation('products')
  const { data: source } = useProductDetail(sourceSku)
  return (
    <div className="mb-4 flex items-start gap-2 rounded-md border bg-muted/50 px-3 py-2 text-sm">
      <Layers className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
      <p>
        {tProducts('variant.bannerPrefix')}{' '}
        <Link
          to={`/products/$sku` as '/products/$sku'}
          params={{ sku: sourceSku }}
          className="font-medium underline"
        >
          {source ? `${source.name} (${sourceSku})` : sourceSku}
        </Link>{' '}
        ·{' '}
        {tProducts(
          share === 1 ? 'variant.bannerShareWhole' : 'variant.bannerShare',
          {
            share: formatShare(share),
          },
        )}{' '}
        <span className="text-muted-foreground">
          {tProducts('variant.bannerInherited')}
        </span>
        {pausedBySource && (
          <span className="mt-1 block font-medium text-warning">
            {tProducts('variant.paused')}
          </span>
        )}
      </p>
    </div>
  )
}
